import { render } from "./Footer.vue?vue&type=template&id=cd12a6e4&scoped=true&ts=true"
import script from "./Footer.ts?vue&type=script&lang=ts&external"
export * from "./Footer.ts?vue&type=script&lang=ts&external"

import "./Footer.vue?vue&type=style&index=0&id=cd12a6e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd12a6e4"]])

export default __exports__